import { Component, Input, Output, OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'br-content-slider',
    templateUrl: './br-content-slider.component.html',
    styles: [`
        .slider-overlay {
        position: fixed;
        z-index: 1000;
        bottom: 0;

        width: 100%;
        height: 100%;
        background-color:rgba(0, 0, 0, 0.5);
        }

        .slider-overlay.hideSlider {
        display: none;
        }

        .slider-overlay.showSlider {
        display: block;
        }

        .content {
        background: #fff;
        box-shadow: 0 -5px 5px -5px #333;
        border: 1px solid #ccc;
        width: 100%;
        position: absolute;
        bottom: 0;
        left: 10px;
        }

        .slider-hide {
            position: absolute;
            right: 125px;
            top: 15px;
            z-index: 100;
        }

        .slider-hide:hover {
            cursor: pointer;
        }

    `]
})

export class ContentSliderComponent implements OnInit, OnDestroy {
    sliderStatus = false;

    @Input() show: Subject<any>;
    @Input() hide: Subject<any>;
    @Input() noToggle: boolean;
    @Input() height: number;
    @Output() close: EventEmitter<any> = new EventEmitter<any>();

    ngOnInit() {

        this.show.subscribe(event => {
            this.sliderStatus = true;
        });

        this.hide.subscribe(event => {
            this.sliderStatus = false;
        });
    }

    showSlider() {
        this.sliderStatus = true;
    }

    hideSlider() {
        this.sliderStatus = false;
    }

    emit() {
        this.close.emit();
    }

    toggleSlider($event) {
        $event.stopPropagation();

        if (!this.noToggle) {
            this.sliderStatus = !this.sliderStatus;
            this.close.emit();
        }
    }

    ngOnDestroy() {
        this.show.unsubscribe();
        this.hide.unsubscribe();

    }
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/brds/widgets/br-content-slider/br-content-slider.component.ts